"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var tenderActions = require("@caddigital/sok-reducers/lib/actions/bid/tender");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var download_1 = require("utils/download");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var revisionActions = require("@caddigital/sok-reducers/lib/actions/revisions");
var mapDispatchToProps = function (dispatch) { return ({
    fetchFilesRequest: function (folder, section) {
        return dispatch(tenderActions.fetchFilesRequest(folder.id, tenderActions.sortByOptions, tenderActions.searchOptions, undefined, section));
    },
    downloadFolder: function (token) { return function (item) {
        var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/download/loading-title'), (0, translation_1.getLocalization)('files/toast/download/loading-text'), 'NORMAL', [], undefined, 0));
        var uuid = retVal.payload.uuid;
        (0, download_1.downloadFiles)(token, [item], undefined, undefined, function () {
            return dispatch(ToastActions.removeToast(uuid));
        });
    }; },
    toggleDocuments: function (item, status) {
        return dispatch(tenderActions.toggleDocuments(item, status));
    },
    fetchLatestReport: function (bid, participant) {
        return dispatch(tenderActions.fetchReliablePartnerReportRequest(bid, participant));
    },
    fetchRevisions: function (revisionUUID) {
        return dispatch(revisionActions.fetchRequest(revisionUUID, 'MINIMAL'));
    },
    fetchParticipants: function (bid, participantId) {
        return dispatch(tenderActions.fetchRequest(bid, participantId));
    },
    clearStatus: function () { return dispatch(tenderActions.clearStatus()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
